import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withXhr } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { environment } from '@environment/environment';
import { CoreRoutingModule } from '@feedback/core/core-routing.module';
import { FeedbackSharedModule } from '@feedback/shared/shared.module';
import { NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ResilientTranslateLoader } from '@shared/loaders/resilient-translate.loader';
import { InterceptorService } from '@shared/services/interceptor.service';
import { CustomPreloadingStrategy } from '@shared/strategies/custom.preloading.strategy';
import { ChartModule, HIGHCHARTS_MODULES } from 'angular-highcharts';
import more from 'highcharts/esm/highcharts-more.src';
import drilldown from 'highcharts/esm/modules/drilldown.src';
import Highcharts from 'highcharts/esm/highcharts.src';
import { NgxSliderModule } from '@angular-slider/ngx-slider';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { SortableModule } from 'ngx-bootstrap/sortable';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { NgXCableModule } from '@shared/modules/action-cable.module';
import { LoggerModule, NgxLoggerLevel } from 'ngx-logger';
import { provideNgxMask } from 'ngx-mask';
import { FacebookPixelModule } from '@shared/modules/facebook-pixel.module';
import { ToastrModule } from 'ngx-toastr';
import { provideNgxWebstorage, withLocalStorage, withNgxWebstorageConfig, withSessionStorage } from 'ngx-webstorage';

// The app has no dark theme; keep Highcharts 13's adaptive palette from
// following the OS color scheme (black chart backgrounds on dark-mode systems)
Highcharts.setOptions({ palette: { colorScheme: 'light' } });

export const createTranslateLoader = (http: HttpClient) =>
  new ResilientTranslateLoader(
    new TranslateHttpLoader(http, './assets/i18n/', '.json')
  );

@NgModule({ exports: [RouterModule, FeedbackSharedModule],
    declarations: [], imports: [FeedbackSharedModule,
        BrowserModule,
        BrowserAnimationsModule,
        ChartModule,
        CoreRoutingModule,
        NgxSliderModule,
        NgXCableModule,
        NgIdleKeepaliveModule.forRoot(),
        SortableModule,
        FacebookPixelModule.forRoot({
            enabled: environment.FB_PIXEL.IS_ENABLED,
            pixelId: environment.FB_PIXEL.PIXEL_ID
        }),
        TabsModule,
        ModalModule,
        BsDatepickerModule,
        LoggerModule.forRoot({
            // serverLoggingUrl: '/logs',
            level: environment.IS_PRODUCTION
                ? NgxLoggerLevel.ERROR
                : NgxLoggerLevel.DEBUG
            // serverLogLevel: NgxLoggerLevel.ERROR
        }),
        ToastrModule.forRoot({
            timeOut: 2000,
            toastClass: 'ngx-toastr v-toastr',
            preventDuplicates: true
        }),
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: createTranslateLoader,
                deps: [HttpClient]
            }
        })], providers: [
        provideNgxWebstorage(withNgxWebstorageConfig({ prefix: 'feedback.vitay.io' }), withLocalStorage(), withSessionStorage()),
        CustomPreloadingStrategy,
        {
            provide: HTTP_INTERCEPTORS,
            useClass: InterceptorService,
            multi: true
        },
        {
            provide: HIGHCHARTS_MODULES,
            useFactory: () => [more, drilldown]
        },
        provideNgxMask(),
        provideHttpClient(withXhr(), withInterceptorsFromDi())
    ] })
export class CoreModule {}
